import api from './api';
import type { Offer } from './offers.service';

export interface ReportQuery {
  from?: string;
  to?: string;
  status?: string;
  agentId?: string;
  closeReason?: string;
}

export const reportsService = {
  list: (query: ReportQuery) =>
    api.get<Offer[]>('/reports/offers', { params: query }).then((r) => r.data),

  exportCsv: (query: ReportQuery) =>
    api
      .get('/reports/offers/export', {
        params: query,
        responseType: 'blob',
      })
      .then((r) => {
        const url = URL.createObjectURL(r.data as Blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `offers-report-${new Date().toISOString().split('T')[0]}.csv`;
        a.click();
        URL.revokeObjectURL(url);
      }),
};
